import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { BorderColorAnimation } from './border-color-animation';
import { MagicIcon } from './bs-icons';

export const DotAnimation = () => {
  return (
    <>
      <div className="flex gap-[2px] flex-shrink-0 relative -left-[4px] top-[3px]">
        <div
          className="w-[2px] h-[2px] rounded-full bg-[#0265FF] flex-shrink-0"
          style={{
            animation: 'pulse 1.4s ease-in-out infinite',
            animationDelay: '0s',
            marginRight: '2px',
          }}
        />
        <div
          className="w-[2px] h-[2px] rounded-full bg-[#0265FF] flex-shrink-0"
          style={{
            animation: 'pulse 1.4s ease-in-out infinite',
            animationDelay: '0.2s',
            marginRight: '2px',
          }}
        />
        <div
          className="w-[2px] h-[2px] rounded-full bg-[#0265FF] flex-shrink-0"
          style={{
            animation: 'pulse 1.4s ease-in-out infinite',
            animationDelay: '0.4s',
          }}
        />
      </div>
      <style>{`
        @keyframes pulse {
          0%, 60%, 100% {
            opacity: 0.3;
            transform: scale(1);
          }
          30% {
            opacity: 1;
            transform: scale(1.2);
          }
        }
      `}</style>
    </>
  );
};

export const FieldsGeneratingIndicator = ({
  children,
  loading = true,
}: {
  children?: React.ReactNode;
  loading?: boolean;
}) => {
  const paddingAndGap = 16 * 2 + 6; // padding + gap
  const animationWidth = loading ? 14 : 0;
  const magicIconWidth = 16;
  const textRef = useRef<HTMLSpanElement>(null);
  const [textWidth, setWidth] = useState(0);

  // get text width + padding + gap
  const fullWidth = textWidth + paddingAndGap + animationWidth + magicIconWidth;

  // when text changes, update width
  useLayoutEffect(() => {
    if (textRef.current) {
      const rect = textRef.current.getBoundingClientRect();
      setWidth(rect.width);
    }
  }, [children]);

  // when text not change, get init width
  useEffect(() => {
    if (textRef.current) {
      const rect = textRef.current.getBoundingClientRect();
      console.log('rect.width', rect.width);
      setWidth(rect.width);
    }
  }, []);

  return (
    <BorderColorAnimation borderRadius={100} width={fullWidth} height={34} borderWidth={1}>
      <div className="flex items-center gap-[6px] h-[31px] ml-[16px]">
        <div className="shrink-0">
          <MagicIcon />
        </div>
        <span className="text-[14px] text-[#0265FF] shrink-0" ref={textRef}>
          {children || '字段生成中'}
        </span>
        {loading && <DotAnimation />}
      </div>
    </BorderColorAnimation>
  );
};
